const API_URL = process.env.REACT_APP_BACKEND_URL || '';

async function sha256(str) {
  const buf = await crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(str)
  );
  return Array.from(new Uint8Array(buf))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

export async function solveChallenge() {
  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);
    const res = await fetch(`${API_URL}/api/security/challenge`, { signal: controller.signal });
    clearTimeout(timeout);
    if (!res.ok) return {};
    const challenge = await res.json();

    const prefix = '0'.repeat(challenge.difficulty);
    let nonce = 0;
    const maxNonce = 300000;

    while (nonce < maxNonce) {
      const hash = await sha256(`${challenge.challenge_id}${nonce}`);
      if (hash.startsWith(prefix)) {
        return {
          'x-challenge-id': challenge.challenge_id,
          'x-challenge-ts': String(challenge.timestamp),
          'x-challenge-diff': String(challenge.difficulty),
          'x-challenge-nonce': String(nonce),
          'x-challenge-sig': challenge.signature,
          'x-hp-field': '',
        };
      }
      nonce++;
      if (nonce % 5000 === 0) {
        await new Promise((r) => setTimeout(r, 0));
      }
    }
    return {};
  } catch {
    return {};
  }
}
